/**
 * @generated SignedSource<<d390b6b7dcd526a512287bc5485d1836>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReplaceMembershipInput = {
  dryRun?: boolean | null | undefined;
  membershipId: string;
  priceMap?: ReadonlyArray<MembershipPriceMapInput> | null | undefined;
  reason?: string | null | undefined;
  replacementMembershipId: string;
};
export type MembershipPriceMapInput = {
  fromPriceId?: string | null | undefined;
  toPriceId?: string | null | undefined;
};
export type useReplaceMembershipMutation$variables = {
  input: ReplaceMembershipInput;
};
export type useReplaceMembershipMutation$data = {
  readonly replaceMembership: {
    readonly canceledButPaid: {
      readonly count: number;
      readonly samples: ReadonlyArray<{
        readonly collidesWithUserMembershipId: string | null | undefined;
        readonly email: string | null | undefined;
        readonly fromPriceId: string | null | undefined;
        readonly newAmount: number | null | undefined;
        readonly nextChargeOn: any | null | undefined;
        readonly oldAmount: number | null | undefined;
        readonly paidUntil: any | null | undefined;
        readonly toPriceId: string | null | undefined;
        readonly userId: string | null | undefined;
        readonly userMembershipId: string;
        readonly userName: string | null | undefined;
      }>;
    };
    readonly collisions: {
      readonly count: number;
      readonly samples: ReadonlyArray<{
        readonly collidesWithUserMembershipId: string | null | undefined;
        readonly email: string | null | undefined;
        readonly fromPriceId: string | null | undefined;
        readonly newAmount: number | null | undefined;
        readonly nextChargeOn: any | null | undefined;
        readonly oldAmount: number | null | undefined;
        readonly paidUntil: any | null | undefined;
        readonly toPriceId: string | null | undefined;
        readonly userId: string | null | undefined;
        readonly userMembershipId: string;
        readonly userName: string | null | undefined;
      }>;
    };
    readonly dryRun: boolean;
    readonly emailDomainExceptions: {
      readonly count: number;
      readonly samples: ReadonlyArray<{
        readonly collidesWithUserMembershipId: string | null | undefined;
        readonly email: string | null | undefined;
        readonly fromPriceId: string | null | undefined;
        readonly newAmount: number | null | undefined;
        readonly nextChargeOn: any | null | undefined;
        readonly oldAmount: number | null | undefined;
        readonly paidUntil: any | null | undefined;
        readonly toPriceId: string | null | undefined;
        readonly userId: string | null | undefined;
        readonly userMembershipId: string;
        readonly userName: string | null | undefined;
      }>;
    };
    readonly free: {
      readonly count: number;
      readonly samples: ReadonlyArray<{
        readonly collidesWithUserMembershipId: string | null | undefined;
        readonly email: string | null | undefined;
        readonly fromPriceId: string | null | undefined;
        readonly newAmount: number | null | undefined;
        readonly nextChargeOn: any | null | undefined;
        readonly oldAmount: number | null | undefined;
        readonly paidUntil: any | null | undefined;
        readonly toPriceId: string | null | undefined;
        readonly userId: string | null | undefined;
        readonly userMembershipId: string;
        readonly userName: string | null | undefined;
      }>;
    };
    readonly membershipId: string;
    readonly movedCount: number;
    readonly paidSameInterval: {
      readonly count: number;
      readonly samples: ReadonlyArray<{
        readonly collidesWithUserMembershipId: string | null | undefined;
        readonly email: string | null | undefined;
        readonly fromPriceId: string | null | undefined;
        readonly newAmount: number | null | undefined;
        readonly nextChargeOn: any | null | undefined;
        readonly oldAmount: number | null | undefined;
        readonly paidUntil: any | null | undefined;
        readonly toPriceId: string | null | undefined;
        readonly userId: string | null | undefined;
        readonly userMembershipId: string;
        readonly userName: string | null | undefined;
      }>;
    };
    readonly pending: {
      readonly count: number;
      readonly samples: ReadonlyArray<{
        readonly collidesWithUserMembershipId: string | null | undefined;
        readonly email: string | null | undefined;
        readonly fromPriceId: string | null | undefined;
        readonly newAmount: number | null | undefined;
        readonly nextChargeOn: any | null | undefined;
        readonly oldAmount: number | null | undefined;
        readonly paidUntil: any | null | undefined;
        readonly toPriceId: string | null | undefined;
        readonly userId: string | null | undefined;
        readonly userMembershipId: string;
        readonly userName: string | null | undefined;
      }>;
    };
    readonly perksToArchive: ReadonlyArray<string>;
    readonly pricesToArchive: ReadonlyArray<string>;
    readonly qrCodeCount: number;
    readonly qrCodeIds: ReadonlyArray<string>;
    readonly replacedOn: any | null | undefined;
    readonly replacementMembershipId: string;
    readonly status: string;
    readonly withUsage: {
      readonly count: number;
      readonly samples: ReadonlyArray<{
        readonly collidesWithUserMembershipId: string | null | undefined;
        readonly email: string | null | undefined;
        readonly fromPriceId: string | null | undefined;
        readonly newAmount: number | null | undefined;
        readonly nextChargeOn: any | null | undefined;
        readonly oldAmount: number | null | undefined;
        readonly paidUntil: any | null | undefined;
        readonly toPriceId: string | null | undefined;
        readonly userId: string | null | undefined;
        readonly userMembershipId: string;
        readonly userName: string | null | undefined;
      }>;
    };
  };
};
export type useReplaceMembershipMutation = {
  response: useReplaceMembershipMutation$data;
  variables: useReplaceMembershipMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MembershipReplaceSample",
    "kind": "LinkedField",
    "name": "samples",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userMembershipId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fromPriceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toPriceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oldAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextChargeOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paidUntil",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "collidesWithUserMembershipId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MembershipReplaceResult",
    "kind": "LinkedField",
    "name": "replaceMembership",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dryRun",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "membershipId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replacementMembershipId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replacedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "movedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipReplaceBucket",
        "kind": "LinkedField",
        "name": "free",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipReplaceBucket",
        "kind": "LinkedField",
        "name": "paidSameInterval",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipReplaceBucket",
        "kind": "LinkedField",
        "name": "pending",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipReplaceBucket",
        "kind": "LinkedField",
        "name": "canceledButPaid",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipReplaceBucket",
        "kind": "LinkedField",
        "name": "collisions",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipReplaceBucket",
        "kind": "LinkedField",
        "name": "withUsage",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipReplaceBucket",
        "kind": "LinkedField",
        "name": "emailDomainExceptions",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "perksToArchive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricesToArchive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "qrCodeCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "qrCodeIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReplaceMembershipMutation",
    "selections": (v2/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReplaceMembershipMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "67c40689ee34aac17985f49c73efccd3",
    "id": null,
    "metadata": {},
    "name": "useReplaceMembershipMutation",
    "operationKind": "mutation",
    "text": "mutation useReplaceMembershipMutation(\n  $input: ReplaceMembershipInput!\n) {\n  replaceMembership(input: $input) {\n    status\n    dryRun\n    membershipId\n    replacementMembershipId\n    replacedOn\n    movedCount\n    free {\n      count\n      samples {\n        userMembershipId\n        userId\n        userName\n        email\n        fromPriceId\n        toPriceId\n        oldAmount\n        newAmount\n        nextChargeOn\n        paidUntil\n        collidesWithUserMembershipId\n      }\n    }\n    paidSameInterval {\n      count\n      samples {\n        userMembershipId\n        userId\n        userName\n        email\n        fromPriceId\n        toPriceId\n        oldAmount\n        newAmount\n        nextChargeOn\n        paidUntil\n        collidesWithUserMembershipId\n      }\n    }\n    pending {\n      count\n      samples {\n        userMembershipId\n        userId\n        userName\n        email\n        fromPriceId\n        toPriceId\n        oldAmount\n        newAmount\n        nextChargeOn\n        paidUntil\n        collidesWithUserMembershipId\n      }\n    }\n    canceledButPaid {\n      count\n      samples {\n        userMembershipId\n        userId\n        userName\n        email\n        fromPriceId\n        toPriceId\n        oldAmount\n        newAmount\n        nextChargeOn\n        paidUntil\n        collidesWithUserMembershipId\n      }\n    }\n    collisions {\n      count\n      samples {\n        userMembershipId\n        userId\n        userName\n        email\n        fromPriceId\n        toPriceId\n        oldAmount\n        newAmount\n        nextChargeOn\n        paidUntil\n        collidesWithUserMembershipId\n      }\n    }\n    withUsage {\n      count\n      samples {\n        userMembershipId\n        userId\n        userName\n        email\n        fromPriceId\n        toPriceId\n        oldAmount\n        newAmount\n        nextChargeOn\n        paidUntil\n        collidesWithUserMembershipId\n      }\n    }\n    emailDomainExceptions {\n      count\n      samples {\n        userMembershipId\n        userId\n        userName\n        email\n        fromPriceId\n        toPriceId\n        oldAmount\n        newAmount\n        nextChargeOn\n        paidUntil\n        collidesWithUserMembershipId\n      }\n    }\n    perksToArchive\n    pricesToArchive\n    qrCodeCount\n    qrCodeIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "596fd63a82084d553d8c2cabf9f31d32";

export default node;
